// Design tokens for Il Pescematto — Elegante marittimo dark theme (web port)

export const colors = {
  // Surfaces
  surface: "#05080F",
  onSurface: "#F7F5F0",
  surfaceSecondary: "#0E1624",
  onSurfaceSecondary: "#E8E4D9",
  surfaceTertiary: "#162235",
  onSurfaceTertiary: "#D0CBBF",
  surfaceInverse: "#F7F5F0",
  onSurfaceInverse: "#05080F",
  muted: "#8E9CAE",

  // Brand
  brand: "#6082B6",
  onBrand: "#05080F",
  brandPrimary: "#C4A464", // gold / sand
  onBrandPrimary: "#05080F",
  brandSecondary: "#6082B6", // dusty blue
  onBrandSecondary: "#F7F5F0",
  brandTertiary: "#26364A",
  onBrandTertiary: "#E8E4D9",

  // Status
  success: "#5EAD6E",
  onSuccess: "#FFFFFF",
  warning: "#C4A464",
  error: "#B95656",
  errorText: "#E5847E",

  // Lines
  border: "#26364A",
  borderStrong: "#3A506B",
  divider: "#1A2639",
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
  xxxl: 48,
};

export const radius = {
  sm: 6,
  md: 12,
  lg: 20,
  pill: 999,
};

export const fonts = {
  display: "'Cormorant Garamond', Georgia, serif",
  body: "'DM Sans', system-ui, -apple-system, sans-serif",
};

export const TAB_BAR_HEIGHT = 64;
export const APP_MAX_WIDTH = 520;
